export const getUrl = window.location.origin + `/api/`
// export const getUrl = "http://bitsom.libcon.co.in/api/"
// export const getUrl = "https://bennett.libcon.in/api/"